import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import bgDialogs from './bg/dialogs.json';
import bgDynamicText from './bg/dynamicText.json';
import bgKit from './bg/kit.json';
import bgKitQuestion from './bg/kitQuestion.json';
import bgLongStatement from './bg/longStatement.json';
import bgPage from './bg/page.json';
import bgText from './bg/text.json';
import csDialogs from './cs/dialogs.json';
import csDynamicText from './cs/dynamicText.json';
import csKit from './cs/kit.json';
import csKitQuestion from './cs/kitQuestion.json';
import csLongStatement from './cs/longStatement.json';
import csPage from './cs/page.json';
import csText from './cs/text.json';
import daDialogs from './da/dialogs.json';
import daDynamicText from './da/dynamicText.json';
import daKit from './da/kit.json';
import daKitQuestion from './da/kitQuestion.json';
import daLongStatement from './da/longStatement.json';
import daPage from './da/page.json';
import daText from './da/text.json';
import deDialogs from './de/dialogs.json';
import deDynamicText from './de/dynamicText.json';
import deKit from './de/kit.json';
import deKitQuestion from './de/kitQuestion.json';
import deLongStatement from './de/longStatement.json';
import dePage from './de/page.json';
import deText from './de/text.json';
import elDialogs from './el/dialogs.json';
import elDynamicText from './el/dynamicText.json';
import elKit from './el/kit.json';
import elKitQuestion from './el/kitQuestion.json';
import elLongStatement from './el/longStatement.json';
import elPage from './el/page.json';
import elText from './el/text.json';
import enUSDialogs from './en-US/dialogs.json';
import enUSDynamicText from './en-US/dynamicText.json';
import enUSKit from './en-US/kit.json';
import enUSKitQuestion from './en-US/kitQuestion.json';
import enUSLongStatement from './en-US/longStatement.json';
import enUSPage from './en-US/page.json';
import enUSText from './en-US/text.json';
import enDialogs from './en/dialogs.json';
import enDynamicText from './en/dynamicText.json';
import enKit from './en/kit.json';
import enKitQuestion from './en/kitQuestion.json';
import enLongStatement from './en/longStatement.json';
import enPage from './en/page.json';
import enText from './en/text.json';
import esESDialogs from './es-ES/dialogs.json';
import esESDynamicText from './es-ES/dynamicText.json';
import esESKit from './es-ES/kit.json';
import esESKitQuestion from './es-ES/kitQuestion.json';
import esESLongStatement from './es-ES/longStatement.json';
import esESPage from './es-ES/page.json';
import esESText from './es-ES/text.json';
import etDialogs from './et/dialogs.json';
import etDynamicText from './et/dynamicText.json';
import etKit from './et/kit.json';
import etKitQuestion from './et/kitQuestion.json';
import etLongStatement from './et/longStatement.json';
import etPage from './et/page.json';
import etText from './et/text.json';
import fiDialogs from './fi/dialogs.json';
import fiDynamicText from './fi/dynamicText.json';
import fiKit from './fi/kit.json';
import fiKitQuestion from './fi/kitQuestion.json';
import fiLongStatement from './fi/longStatement.json';
import fiPage from './fi/page.json';
import fiText from './fi/text.json';
import frDialogs from './fr/dialogs.json';
import frDynamicText from './fr/dynamicText.json';
import frKit from './fr/kit.json';
import frKitQuestion from './fr/kitQuestion.json';
import frLongStatement from './fr/longStatement.json';
import frPage from './fr/page.json';
import frText from './fr/text.json';
import hrDialogs from './hr/dialogs.json';
import hrDynamicText from './hr/dynamicText.json';
import hrKit from './hr/kit.json';
import hrKitQuestion from './hr/kitQuestion.json';
import hrLongStatement from './hr/longStatement.json';
import hrPage from './hr/page.json';
import hrText from './hr/text.json';
import huDialogs from './hu/dialogs.json';
import huDynamicText from './hu/dynamicText.json';
import huKit from './hu/kit.json';
import huKitQuestion from './hu/kitQuestion.json';
import huLongStatement from './hu/longStatement.json';
import huPage from './hu/page.json';
import huText from './hu/text.json';
import itDialogs from './it/dialogs.json';
import itDynamicText from './it/dynamicText.json';
import itKit from './it/kit.json';
import itKitQuestion from './it/kitQuestion.json';
import itLongStatement from './it/longStatement.json';
import itPage from './it/page.json';
import itText from './it/text.json';
import lbDialogs from './lb/dialogs.json';
import lbDynamicText from './lb/dynamicText.json';
import lbKit from './lb/kit.json';
import lbKitQuestion from './lb/kitQuestion.json';
import lbLongStatement from './lb/longStatement.json';
import lbPage from './lb/page.json';
import lbText from './lb/text.json';
import ltDialogs from './lt/dialogs.json';
import ltDynamicText from './lt/dynamicText.json';
import ltKit from './lt/kit.json';
import ltKitQuestion from './lt/kitQuestion.json';
import ltLongStatement from './lt/longStatement.json';
import ltPage from './lt/page.json';
import ltText from './lt/text.json';
import lvDialogs from './lv/dialogs.json';
import lvDynamicText from './lv/dynamicText.json';
import lvKit from './lv/kit.json';
import lvKitQuestion from './lv/kitQuestion.json';
import lvLongStatement from './lv/longStatement.json';
import lvPage from './lv/page.json';
import lvText from './lv/text.json';
import mtDialogs from './mt/dialogs.json';
import mtDynamicText from './mt/dynamicText.json';
import mtKit from './mt/kit.json';
import mtKitQuestion from './mt/kitQuestion.json';
import mtLongStatement from './mt/longStatement.json';
import mtPage from './mt/page.json';
import mtText from './mt/text.json';
import nlBEDialogs from './nl-BE/dialogs.json';
import nlBEDynamicText from './nl-BE/dynamicText.json';
import nlBEKit from './nl-BE/kit.json';
import nlBEKitQuestion from './nl-BE/kitQuestion.json';
import nlBELongStatement from './nl-BE/longStatement.json';
import nlBEPage from './nl-BE/page.json';
import nlBEText from './nl-BE/text.json';
import nlNLDialogs from './nl-NL/dialogs.json';
import nlNLDynamicText from './nl-NL/dynamicText.json';
import nlNLKit from './nl-NL/kit.json';
import nlNLKitQuestion from './nl-NL/kitQuestion.json';
import nlNLLongStatement from './nl-NL/longStatement.json';
import nlNLPage from './nl-NL/page.json';
import nlNLText from './nl-NL/text.json';
import noDialogs from './no/dialogs.json';
import noDynamicText from './no/dynamicText.json';
import noKit from './no/kit.json';
import noKitQuestion from './no/kitQuestion.json';
import noLongStatement from './no/longStatement.json';
import noPage from './no/page.json';
import noText from './no/text.json';
import plDialogs from './pl/dialogs.json';
import plDynamicText from './pl/dynamicText.json';
import plKit from './pl/kit.json';
import plKitQuestion from './pl/kitQuestion.json';
import plLongStatement from './pl/longStatement.json';
import plPage from './pl/page.json';
import plText from './pl/text.json';
import ptPTDialogs from './pt-PT/dialogs.json';
import ptPTDynamicText from './pt-PT/dynamicText.json';
import ptPTKit from './pt-PT/kit.json';
import ptPTKitQuestion from './pt-PT/kitQuestion.json';
import ptPTLongStatement from './pt-PT/longStatement.json';
import ptPTPage from './pt-PT/page.json';
import ptPTText from './pt-PT/text.json';
import roRODialogs from './ro-RO/dialogs.json';
import roRODynamicText from './ro-RO/dynamicText.json';
import roROKit from './ro-RO/kit.json';
import roROKitQuestion from './ro-RO/kitQuestion.json';
import roROLongStatement from './ro-RO/longStatement.json';
import roROPage from './ro-RO/page.json';
import roROText from './ro-RO/text.json';
import skDialogs from './sk/dialogs.json';
import skDynamicText from './sk/dynamicText.json';
import skKit from './sk/kit.json';
import skKitQuestion from './sk/kitQuestion.json';
import skLongStatement from './sk/longStatement.json';
import skPage from './sk/page.json';
import skText from './sk/text.json';
import slDialogs from './sl/dialogs.json';
import slDynamicText from './sl/dynamicText.json';
import slKit from './sl/kit.json';
import slKitQuestion from './sl/kitQuestion.json';
import slLongStatement from './sl/longStatement.json';
import slPage from './sl/page.json';
import slText from './sl/text.json';
import svDialogs from './sv/dialogs.json';
import svDynamicText from './sv/dynamicText.json';
import svKit from './sv/kit.json';
import svKitQuestion from './sv/kitQuestion.json';
import svLongStatement from './sv/longStatement.json';
import svPage from './sv/page.json';
import svText from './sv/text.json';
import zhHansDialogs from './zh-Hans/dialogs.json';
import zhHansDynamicText from './zh-Hans/dynamicText.json';
import zhHansKit from './zh-Hans/kit.json';
import zhHansKitQuestion from './zh-Hans/kitQuestion.json';
import zhHansLongStatement from './zh-Hans/longStatement.json';
import zhHansPage from './zh-Hans/page.json';
import zhHansText from './zh-Hans/text.json';
export var resources = {
  bg: {
    kit: _objectSpread(_objectSpread({}, bgKit), bgKitQuestion),
    page: _objectSpread({}, bgPage),
    dynamicText: _objectSpread({}, bgDynamicText),
    text: _objectSpread({}, bgText),
    longStatement: _objectSpread({}, bgLongStatement),
    dialogs: _objectSpread({}, bgDialogs)
  },
  cs: {
    kit: _objectSpread(_objectSpread({}, csKit), csKitQuestion),
    page: _objectSpread({}, csPage),
    dynamicText: _objectSpread({}, csDynamicText),
    text: _objectSpread({}, csText),
    longStatement: _objectSpread({}, csLongStatement),
    dialogs: _objectSpread({}, csDialogs)
  },
  da: {
    kit: _objectSpread(_objectSpread({}, daKit), daKitQuestion),
    page: _objectSpread({}, daPage),
    dynamicText: _objectSpread({}, daDynamicText),
    text: _objectSpread({}, daText),
    longStatement: _objectSpread({}, daLongStatement),
    dialogs: _objectSpread({}, daDialogs)
  },
  de: {
    kit: _objectSpread(_objectSpread({}, deKit), deKitQuestion),
    page: _objectSpread({}, dePage),
    dynamicText: _objectSpread({}, deDynamicText),
    text: _objectSpread({}, deText),
    longStatement: _objectSpread({}, deLongStatement),
    dialogs: _objectSpread({}, deDialogs)
  },
  // 'de-AT': {
  //   kit: {
  //     ...deATKit,
  //     ...deATKitQuestion,
  //   },
  //   page: {
  //     ...deATPage,
  //   },
  //   dynamicText: {
  //     ...deATDynamicText,
  //   },
  //   text: {
  //     ...deATText,
  //   },
  //   longStatement: {
  //     ...deATLongStatement,
  //   },
  //   dialogs: {
  //     ...deATDialogs,
  //   },
  // },
  'de-AT': {
    kit: _objectSpread(_objectSpread({}, deKit), deKitQuestion),
    page: _objectSpread({}, dePage),
    dynamicText: _objectSpread({}, deDynamicText),
    text: _objectSpread({}, deText),
    longStatement: _objectSpread({}, deLongStatement),
    dialogs: _objectSpread({}, deDialogs)
  },
  el: {
    kit: _objectSpread(_objectSpread({}, elKit), elKitQuestion),
    page: _objectSpread({}, elPage),
    dynamicText: _objectSpread({}, elDynamicText),
    text: _objectSpread({}, elText),
    longStatement: _objectSpread({}, elLongStatement),
    dialogs: _objectSpread({}, elDialogs)
  },
  en: {
    kit: _objectSpread(_objectSpread({}, enKit), enKitQuestion),
    page: _objectSpread({}, enPage),
    dynamicText: _objectSpread({}, enDynamicText),
    text: _objectSpread({}, enText),
    longStatement: _objectSpread({}, enLongStatement),
    dialogs: _objectSpread({}, enDialogs)
  },
  'en-US': {
    kit: _objectSpread(_objectSpread({}, enUSKit), enUSKitQuestion),
    page: _objectSpread({}, enUSPage),
    dynamicText: _objectSpread({}, enUSDynamicText),
    text: _objectSpread({}, enUSText),
    longStatement: _objectSpread({}, enUSLongStatement),
    dialogs: _objectSpread({}, enUSDialogs)
  },
  'es-ES': {
    kit: _objectSpread(_objectSpread({}, esESKit), esESKitQuestion),
    page: _objectSpread({}, esESPage),
    dynamicText: _objectSpread({}, esESDynamicText),
    text: _objectSpread({}, esESText),
    longStatement: _objectSpread({}, esESLongStatement),
    dialogs: _objectSpread({}, esESDialogs)
  },
  et: {
    kit: _objectSpread(_objectSpread({}, etKit), etKitQuestion),
    page: _objectSpread({}, etPage),
    dynamicText: _objectSpread({}, etDynamicText),
    text: _objectSpread({}, etText),
    longStatement: _objectSpread({}, etLongStatement),
    dialogs: _objectSpread({}, etDialogs)
  },
  fi: {
    kit: _objectSpread(_objectSpread({}, fiKit), fiKitQuestion),
    page: _objectSpread({}, fiPage),
    dynamicText: _objectSpread({}, fiDynamicText),
    text: _objectSpread({}, fiText),
    longStatement: _objectSpread({}, fiLongStatement),
    dialogs: _objectSpread({}, fiDialogs)
  },
  fr: {
    kit: _objectSpread(_objectSpread({}, frKit), frKitQuestion),
    page: _objectSpread({}, frPage),
    dynamicText: _objectSpread({}, frDynamicText),
    text: _objectSpread({}, frText),
    longStatement: _objectSpread({}, frLongStatement),
    dialogs: _objectSpread({}, frDialogs)
  },
  // ga: {
  //   kit: {
  //     ...gaKit,
  //     ...gaKitQuestion,
  //   },
  //   page: {
  //     ...gaPage,
  //   },
  //   dynamicText: {
  //     ...gaDynamicText,
  //   },
  //   text: {
  //     ...gaText,
  //   },
  //   longStatement: {
  //     ...gaLongStatement,
  //   },
  //   dialogs: {
  //     ...gaDialogs,
  //   },
  // },
  ga: {
    kit: _objectSpread(_objectSpread({}, enKit), enKitQuestion),
    page: _objectSpread({}, enPage),
    dynamicText: _objectSpread({}, enDynamicText),
    text: _objectSpread({}, enText),
    longStatement: _objectSpread({}, enLongStatement),
    dialogs: _objectSpread({}, enDialogs)
  },
  hr: {
    kit: _objectSpread(_objectSpread({}, hrKit), hrKitQuestion),
    page: _objectSpread({}, hrPage),
    dynamicText: _objectSpread({}, hrDynamicText),
    text: _objectSpread({}, hrText),
    longStatement: _objectSpread({}, hrLongStatement),
    dialogs: _objectSpread({}, hrDialogs)
  },
  hu: {
    kit: _objectSpread(_objectSpread({}, huKit), huKitQuestion),
    page: _objectSpread({}, huPage),
    dynamicText: _objectSpread({}, huDynamicText),
    text: _objectSpread({}, huText),
    longStatement: _objectSpread({}, huLongStatement),
    dialogs: _objectSpread({}, huDialogs)
  },
  it: {
    kit: _objectSpread(_objectSpread({}, itKit), itKitQuestion),
    page: _objectSpread({}, itPage),
    dynamicText: _objectSpread({}, itDynamicText),
    text: _objectSpread({}, itText),
    longStatement: _objectSpread({}, itLongStatement),
    dialogs: _objectSpread({}, itDialogs)
  },
  lb: {
    kit: _objectSpread(_objectSpread({}, lbKit), lbKitQuestion),
    page: _objectSpread({}, lbPage),
    dynamicText: _objectSpread({}, lbDynamicText),
    text: _objectSpread({}, lbText),
    longStatement: _objectSpread({}, lbLongStatement),
    dialogs: _objectSpread({}, lbDialogs)
  },
  lt: {
    kit: _objectSpread(_objectSpread({}, ltKit), ltKitQuestion),
    page: _objectSpread({}, ltPage),
    dynamicText: _objectSpread({}, ltDynamicText),
    text: _objectSpread({}, ltText),
    longStatement: _objectSpread({}, ltLongStatement),
    dialogs: _objectSpread({}, ltDialogs)
  },
  lv: {
    kit: _objectSpread(_objectSpread({}, lvKit), lvKitQuestion),
    page: _objectSpread({}, lvPage),
    dynamicText: _objectSpread({}, lvDynamicText),
    text: _objectSpread({}, lvText),
    longStatement: _objectSpread({}, lvLongStatement),
    dialogs: _objectSpread({}, lvDialogs)
  },
  mt: {
    kit: _objectSpread(_objectSpread({}, mtKit), mtKitQuestion),
    page: _objectSpread({}, mtPage),
    dynamicText: _objectSpread({}, mtDynamicText),
    text: _objectSpread({}, mtText),
    longStatement: _objectSpread({}, mtLongStatement),
    dialogs: _objectSpread({}, mtDialogs)
  },
  'nl-BE': {
    kit: _objectSpread(_objectSpread({}, nlBEKit), nlBEKitQuestion),
    page: _objectSpread({}, nlBEPage),
    dynamicText: _objectSpread({}, nlBEDynamicText),
    text: _objectSpread({}, nlBEText),
    longStatement: _objectSpread({}, nlBELongStatement),
    dialogs: _objectSpread({}, nlBEDialogs)
  },
  'nl-NL': {
    kit: _objectSpread(_objectSpread({}, nlNLKit), nlNLKitQuestion),
    page: _objectSpread({}, nlNLPage),
    dynamicText: _objectSpread({}, nlNLDynamicText),
    text: _objectSpread({}, nlNLText),
    longStatement: _objectSpread({}, nlNLLongStatement),
    dialogs: _objectSpread({}, nlNLDialogs)
  },
  no: {
    kit: _objectSpread(_objectSpread({}, noKit), noKitQuestion),
    page: _objectSpread({}, noPage),
    dynamicText: _objectSpread({}, noDynamicText),
    text: _objectSpread({}, noText),
    longStatement: _objectSpread({}, noLongStatement),
    dialogs: _objectSpread({}, noDialogs)
  },
  pl: {
    kit: _objectSpread(_objectSpread({}, plKit), plKitQuestion),
    page: _objectSpread({}, plPage),
    dynamicText: _objectSpread({}, plDynamicText),
    text: _objectSpread({}, plText),
    longStatement: _objectSpread({}, plLongStatement),
    dialogs: _objectSpread({}, plDialogs)
  },
  'pt-PT': {
    kit: _objectSpread(_objectSpread({}, ptPTKit), ptPTKitQuestion),
    page: _objectSpread({}, ptPTPage),
    dynamicText: _objectSpread({}, ptPTDynamicText),
    text: _objectSpread({}, ptPTText),
    longStatement: _objectSpread({}, ptPTLongStatement),
    dialogs: _objectSpread({}, ptPTDialogs)
  },
  'ro-RO': {
    kit: _objectSpread(_objectSpread({}, roROKit), roROKitQuestion),
    page: _objectSpread({}, roROPage),
    dynamicText: _objectSpread({}, roRODynamicText),
    text: _objectSpread({}, roROText),
    longStatement: _objectSpread({}, roROLongStatement),
    dialogs: _objectSpread({}, roRODialogs)
  },
  sk: {
    kit: _objectSpread(_objectSpread({}, skKit), skKitQuestion),
    page: _objectSpread({}, skPage),
    dynamicText: _objectSpread({}, skDynamicText),
    text: _objectSpread({}, skText),
    longStatement: _objectSpread({}, skLongStatement),
    dialogs: _objectSpread({}, skDialogs)
  },
  sl: {
    kit: _objectSpread(_objectSpread({}, slKit), slKitQuestion),
    page: _objectSpread({}, slPage),
    dynamicText: _objectSpread({}, slDynamicText),
    text: _objectSpread({}, slText),
    longStatement: _objectSpread({}, slLongStatement),
    dialogs: _objectSpread({}, slDialogs)
  },
  sv: {
    kit: _objectSpread(_objectSpread({}, svKit), svKitQuestion),
    page: _objectSpread({}, svPage),
    dynamicText: _objectSpread({}, svDynamicText),
    text: _objectSpread({}, svText),
    longStatement: _objectSpread({}, svLongStatement),
    dialogs: _objectSpread({}, svDialogs)
  },
  'zh-Hans': {
    kit: _objectSpread(_objectSpread({}, zhHansKit), zhHansKitQuestion),
    page: _objectSpread({}, zhHansPage),
    dynamicText: _objectSpread({}, zhHansDynamicText),
    text: _objectSpread({}, zhHansText),
    longStatement: _objectSpread({}, zhHansLongStatement),
    dialogs: _objectSpread({}, zhHansDialogs)
  }
};